/// <amd-module name="TFS/Admin/Groups/Pivots/Groups/DataSource/GroupsPivotDataSource" />
import { IGroupsViewData } from "TFS/Admin/Groups/Common/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const OrgAdminGroupsDataProvider = "ms.vss-admin-web.org-admin-groups-data-provider";
const membersDataProvider = "ms.vss-admin-web.org-admin-group-members-data-provider";

export function getTopLevelGroups(pageContext: IVssPageContext, requestParameters?: { [key: string]: any }): Promise<IGroupsViewData | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService.getDataAsync<IGroupsViewData>(OrgAdminGroupsDataProvider, requestParameters, true).then((result) => {
        return result;
    });
}

export function getGroupMembersList(pageContext: IVssPageContext, requestParameters?: { [key: string]: any }): Promise<IGroupsViewData | undefined> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    return contributionService.getDataAsync<IGroupsViewData>(membersDataProvider, requestParameters, true).then((result) => {
        return result;
    });
}
